import { createSlice } from "@reduxjs/toolkit";

export const capitalDetailsSlice = createSlice({
  name: "capitalDetails",
  initialState: {
    init: false,
    widget: null,
    formattedBalance: null,
    difference: null,
    numberOfSources: null,
    lineChartData: null,
    portfolioChartData: null,
    categoriesChartData: null,
  },
  reducers: {
    setData: (state, action) => {
      const {
        formattedBalance,
        difference,
        numberOfSources,
        lineChartData,
        portfolioChartData,
        categoriesChartData,
      } = action.payload;
      state.formattedBalance = formattedBalance;
      state.difference = difference;
      state.numberOfSources = numberOfSources;
      state.lineChartData = lineChartData;
      state.portfolioChartData = portfolioChartData;
      state.categoriesChartData = categoriesChartData;
      state.init = true;
    },
  },
});

export const { setData } = capitalDetailsSlice.actions;

export default capitalDetailsSlice.reducer;
